import React from 'react';
import fr from 'facet-rest';
import { relationshipType } from 'facet-rest/src/consts/relationships';
import TabGroup from 'Components/ComponentLibrary/Molecules/TabGroup/TabGroup';
import {
  ActivityTabContainer,
} from 'Views/Page/Content/Templates/MemberDashboard/content/ActivityTabs/content/ActivityTabLayout/ActivityTabContainer';

const ActivityTabs = ({ resource }) => {
  // Get all the tab relationships, render if there are more than 1
  const tabRelationships = resource.relationships().list().filter((rel) => rel.meta('type') === relationshipType.tabLink);
  if (tabRelationships.length === 0) {
    return null;
  }

  const LAYOUTS = {
    [fr.relationships.myActions.name]: (<ActivityTabContainer relationship={resource.relationship(fr.relationships.myActions.name)} />),
    [fr.relationships.teamActions.name]: (<ActivityTabContainer relationship={resource.relationship(fr.relationships.teamActions.name)} showFilters />),
    [fr.relationships.memberActions.name]: (<ActivityTabContainer relationship={resource.relationship(fr.relationships.memberActions.name)} />),
  };

  return (
    <TabGroup resource={resource} layouts={LAYOUTS} tabAlignment={'flex-start'} />
  );
};

ActivityTabs.defaultProps = {};

ActivityTabs.propTypes = {
  resource: fr.Resource.isRequired,
};

export { ActivityTabs };
